/**
 * @returns {import('solid-js').JSX.Element} A UILoading
 */
export function UILoading() {
  return <span className="tw:d-loading tw:d-loading-xl tw:d-loading-ring" />;
}
